import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo} from 'react';

import InfoBox from '@/components/InfoBox';

const FieldSetGroupDivider = ({title, className, help, children}) => {
  
  return <>
    <fieldset className={classNames('mt-2', className)}>
      <legend
        style={{borderColor: '#f0f0f0', fontSize: '14px'}}
        className={classNames('text-black', {'mb-0': !!help}, className)}>
        {title}
      </legend>
    </fieldset>
    <div className={classNames({'mb-6': help && !children})}>
      <InfoBox title={help}/>
    </div>
    {children}
  </>;
  
};

FieldSetGroupDivider.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  help: PropTypes.string,
  title: PropTypes.string
};

FieldSetGroupDivider.defaultProps = {};

export default memo(FieldSetGroupDivider);
